import * as React from 'react';

const MOBILE_BREAKPOINT = 768;
// Flexar: ниже этой ширины в чате не помещаются одновременно список диалогов и сама переписка.
// Замерено: на 1024px панель забирает 272px, карточка чата сжимается до 580px и строка моделей
// ломается в три ряда; на 768px чат оставался 324px. Там же, где панель прячется, появляется
// кнопка, открывающая её шитом.
export const CHAT_COMPACT_BREAKPOINT = 1280;

export function useIsBelow(breakpoint: number) {
  const [isBelow, setIsBelow] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const onChange = () => {
      setIsBelow(window.innerWidth < breakpoint);
    };
    mql.addEventListener('change', onChange);
    setIsBelow(window.innerWidth < breakpoint);
    return () => mql.removeEventListener('change', onChange);
  }, [breakpoint]);

  return !!isBelow;
}

export function useIsMobile() {
  return useIsBelow(MOBILE_BREAKPOINT);
}
